import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/flag.png'


const _withScopeId = n => (_pushScopeId("data-v-46c003a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "over-header bg-black text-white" }
const _hoisted_2 = { class: "container-xl header-container" }
const _hoisted_3 = { class: "row justify-content-between" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col over-header-item" }
const _hoisted_7 = { class: "col over-header-item" }
const _hoisted_8 = {
  class: "fw-semibold",
  href: "#"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row align-items-center justify-content-end" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col over-header-item pe-0" }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"5px"} }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fas fa-headphones-alt" })
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        class: "fw-semibold",
        href: "#"
      }, " Поддержка ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col over-header-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "fw-semibold dropdown",
        href: "#",
        role: "button",
        id: "dropdownMenuLink",
        "data-bs-toggle": "dropdown",
        "aria-expanded": "false"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          class: "flag",
          alt: "flag"
        }),
        /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"5px"} }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-down" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("ul", {
        class: "dropdown-menu",
        "aria-labelledby": "dropdownMenuLink"
      }, [
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", {
            class: "dropdown-item",
            href: "#"
          }, "Русский")
        ])
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                class: _normalizeClass(["fw-semibold", {'active':  this.$route.name == 'about_us'}]),
                to: {name: 'about_us'}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("О нас")
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _createTextVNode(" • "),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, [
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["fw-semibold", {'active':  this.$route.name == 'community'}]),
                  to: {name: 'community'}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Сообщество")
                  ]),
                  _: 1
                }, 8, ["class"])
              ])
            ])
          ])
        ]),
        _hoisted_9
      ])
    ])
  ]))
}